import script from "./ProjectSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSidebar.vue?vue&type=style&index=0&id=0c8b4a5e&lang=scss"

const __exports__ = script;

export default __exports__